import React, { useState, useEffect } from "react";
import ObjCommonFilterSelection from "../../../component/custom/ObjCommonFilterSelection";
import Quote from "@system/config/quote";
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import Constants from "../../../helper/Constants";

export function QuoteListingSearchFilter() {
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const { siteUser } = Constants;

    const modal = {
        searchType: '',
        searchKeyword: ''
    }
    const [searchModal, setSearchModal] = useState(modal);
    const [validation, setValidation] = useState({});

    const ddlValues = {
        quoteNumber: "Quote Number",
        manufacturerPartNumber: "Manufacturer Part Number",
        projectName: "Project Name",
    }
    if (System.avUserInfoData.currentUser === siteUser.CORE) {
        ddlValues.customerPartNumber = "Customer Part Number";
    }
    const onValueChange = (field, value) => {
        setSearchModal({ ...searchModal, [field]: value });
        setValidation({})
    }

    const onChangeSearchBy = (value) => {
        setSearchModal({ searchType: value, searchKeyword: '' });
        setValidation({})
    }

    useEffect(() => {
        let flag = true;
        Object.entries(filter_list).forEach(([key, value]) => {
            if (Object.keys(ddlValues).includes(key)) {
                flag = false;
                setSearchModal({
                    searchType: key,
                    searchKeyword: value.searchKeyword
                });
            }
        })
        if (flag) {
            setSearchModal({
                searchType: "",
                searchKeyword: ""
            });
        }
    }, [filter_list])

    const validateValue = () => {
        const _validation = {};
        let isValid = true;
        if (searchModal.searchType === "") {
            _validation.searchType = `Please select a "Search By" Option`;
            isValid = false;
        }

        if (Helper.valueIsNotNull(searchModal.searchKeyword)) {
            if (searchModal.searchKeyword.length < 3) {
                _validation.searchKeyword = "Please enter at least 3 characters to execute a keyword search "
                isValid = false;
            }
        } else {
            _validation.searchKeyword = "Search value is required"
            isValid = false;
        }

        setValidation(_validation)
        return isValid;
    }

    const onSearch = () => {
        const isValid = validateValue();
        if (!isValid) {
            return;
        }
        set_filter_list({
            ...filter_list,
            [searchModal.searchType]: {
                searchType: [ddlValues[searchModal.searchType]],
                searchKeyword: searchModal.searchKeyword
            }
        });
    }
    return (
        <>
            <div className='sub-title mt-0'>My Submitted Quotes</div>
            <p className='mb-4'>Quotes that have been sent to the sales representative. Contains all your submitted
                online and offline quotes.</p>

            <div className="ps5 d-flex align-items-center mb-0 quote-tabs-links">
                <a href={Quote.getQuoteRouteURL()}>My Open Quotes</a>
                <p className="ps5 text-black-stone mb-0 ms-1">My Submitted Quotes</p>
            </div>
            <div className='quote-tabs-content'>
                <div className="d-flex align-items-top p-3">
                    <div>
                        <div className="dropdown quote-search-dd me-3">
                            <div className="selectbox">
                                <select className="form-control form-control-sm mr-3" aria-label="SearchBy"
                                    value={searchModal.searchType}
                                    placeholder="Search By"
                                    id="searchType" onChange={(e) => {
                                        onChangeSearchBy(e.target.value)
                                    }}>
                                    <option value="">Search By</option>
                                    {ddlValues && Object.entries(ddlValues).map((v, i) => (
                                        <option key={v[0]} value={v[0]}>{v[1]}</option>
                                    ))}
                                </select>
                            </div>
                            <p className="error">{validation?.searchType && validation.searchType}</p>
                        </div>
                    </div>
                    <div className="w250">
                        <div className="bs5 input-group flex-nowrap">
                            <input type="text" className="form-control form-control-sm"
                                placeholder="Search by keyword" id="searchKeyword"
                                value={searchModal.searchKeyword}
                                onChange={({ target: { value } }) => onValueChange('searchKeyword', value)}
                                minLength={3} />
                            <a href={void (0)}
                                className="bs5 btn btn-secondary d-flex align-items-center rounded-right-1"
                                onClick={onSearch}><i className="fa fa-search text-black-stone"></i></a>
                        </div>
                        <p className="error">{validation?.searchKeyword && validation.searchKeyword}</p>
                    </div>
                    <div className="bs5  m-1 p-1">
                        <a href={void (0)} data-toggle="modal" data-target="#delete-quote-Modal"
                            onClick={(e) => {
                                e.preventDefault();
                                System.popup('QuoteAdvanceFilterPopup')
                            }}>Advanced Filters</a>
                    </div>
                    <div className="bs5 pt-1 m-1 ms-auto">Booking and {' '}
                        <a href={Constants.PDFQuoteLink} target={"_blank"}
                            data-placement="bottom" data-toggle="tooltip"
                            data-html="true" rel="noreferrer"><i className="fa fa-info-circle me-2 text-black"
                                aria-hidden="true" />
                            <span className="text-blue">Information</span></a>
                    </div>
                </div>
                <div className='px-3'>
                    <ObjCommonFilterSelection />
                </div>
            </div>
        </>
    );

}